module.exports = __webpack_public_path__ + "img/consultoria_9-16_1620.a3c11759.webp";